export const dinoGameUrls = ["chrome://dino"];

export const surfGameUrls = ["edge://surf"];

export const blankTabUrls = ["about:blank"];

export const googleNewTabUrls = ["chrome://newtab"];

export const edgeNewTabUrls = ["edge://newtab", "edge://welcome"];

export const cameraAppUrls = ["chrome://camera-app"];

export const screencastAppUrls = ["chrome-untrusted://projector"];

export const mediaAppUrls = ["chrome://media-app", "chrome-untrusted://media-app"];

export const fileUrls = [
	"file://",
	"chrome://file-manager",
	"chrome-extension://efaidnbmnnnibpcajpcglclefindmkaj", // Adobe PDF Viewer extension
	"externalfile://",
];

export const browsingToolsUrls = [
	"chrome-untrusted://compose",
	"chrome-untrusted://lens",
	"chrome-untrusted://print",
	"chrome://cast-feedback",
	"chrome://connection-help",
	"chrome://feedback",
	"chrome://print",
	"chrome://quit",
	"chrome://restart",
	"chrome://support-tool",
	"chrome://apps",
	"chrome://bookmarks",
	"chrome://chrome",
	"chrome://downloads",
	"edge://downloads",
	"chrome://history",
	"edge://history",
	"edge://favorites",
	"chrome://new-tab-page",
	"chrome://new-tab-page-third-party",
	"chrome://access-code-cast",
	"chrome-untrusted://read-anything-side-panel.top-chrome",
];

export const chromeSettingsUrls = [
	"chrome://glic-fre",
	"chrome://intro",
	"chrome-untrusted://ntp-microsoft-auth",
	"chrome://chrome-signin",
	"chrome://history-sync-optin",
	"chrome://profile-picker",
	"chrome://reset-password",
	"chrome://signin-dice-web-intercept.top-chrome",
	"chrome://signin-email-confirmation",
	"chrome://signin-error",
	"chrome://signout-confirmation",
	"chrome://sync-confirmation",
	"chrome-untrusted://data-sharing",
	"chrome-untrusted://lens-overlay",
	"chrome://bookmarks-side-panel.top-chrome",
	"chrome://comments-side-panel.top-chrome",
	"chrome://customize-chrome-side-panel.top-chrome",
	"chrome://extensions-zero-state",
	"chrome://history-clusters-side-panel.top-chrome",
	"chrome://history-side-panel.top-chrome",
	"chrome://newtab-footer",
	"chrome://omnibox-popup.top-chrome",
	"chrome://read-later.top-chrome",
	"chrome://reload-button.top-chrome",
	"chrome://shopping-insights-side-panel.top-chrome",
	"chrome://tab-group-home",
	"chrome://tab-search.top-chrome",
	"chrome://tab-strip.top-chrome",
	"chrome://components",
	"chrome://accessibility",
	"chrome://browser-switch",
	"chrome://flags",
	"chrome://certificate-manager",
	"chrome://password-manager",
	"chrome://safe-browsing",
	"chrome://sandbox",
	"chrome://view-cert",
	"chrome-untrusted://privacy-sandbox-dialog",
	"chrome://attribution-internals",
	"chrome://privacy-sandbox-base-dialog",
	"chrome://privacy-sandbox-dialog",
	"chrome://privacy-sandbox-internals",
	"chrome://private-aggregation-internals",
	"chrome://topics-internals",
	"chrome://chrome-urls",
	"chrome://credits",
	"chrome://managed-user-profile-notice",
	"chrome://saved-tab-groups-unsupported",
	"chrome://terms",
	"chrome://version",
	"chrome://whats-new",
	"chrome://app-settings",
	"chrome://extensions",
	"chrome://management",
	"chrome://policy",
	"chrome://profile-customization",
	"chrome://search-engine-choice",
	"chrome://settings",
];

export const edgeSettingsUrls = ["edge://settings", "edge://extensions", "edge://management"];

export const developerToolsUrls = [
	"chrome://bluetooth-internals",
	"chrome://gpu",
	"chrome://usb-internals",
	"chrome://conflicts",
	"chrome://connection-monitoring-detected",
	"chrome://crashes",
	"chrome://device-log",
	"chrome://net-export",
	"chrome://net-internals",
	"chrome://sync-internals",
	"chrome://system",
	"chrome://actor-internals",
	"chrome://actor-overlay",
	"chrome://app-service-internals",
	"chrome://autofill-internals",
	"chrome://autofill-ml-internals",
	"chrome://batch-upload",
	"chrome://blob-internals",
	"chrome://color-pipeline-internals",
	"chrome://commerce-internals",
	"chrome://compare",
	"chrome://connectors-internals",
	"chrome://contextual-tasks",
	"chrome://data-sharing-internals",
	"chrome://debug-webuis-disabled",
	"chrome://discards",
	"chrome://download-internals",
	"chrome://extensions-internals",
	"chrome://family-link-user-internals",
	"chrome://gcm-internals",
	"chrome://glic",
	"chrome://histograms",
	"chrome://history-clusters-internals",
	"chrome://indexeddb-internals",
	"chrome://infobar-internals",
	"chrome://internals",
	"chrome://interstitials",
	"chrome://local-state",
	"chrome://location-internals",
	"chrome://media-engagement",
	"chrome://media-internals",
	"chrome://media-router-internals",
	"chrome://memory-internals",
	"chrome://metrics-internals",
	"chrome://network-errors",
	"chrome://ntp-tiles-internals",
	"chrome://omnibox",
	"chrome://on-device-internals",
	"chrome://on-device-translation-internals",
	"chrome://optimization-guide-internals",
	"chrome://password-manager-internals",
	"chrome://predictors",
	"chrome://process-internals",
	"chrome://profile-internals",
	"chrome://quota-internals",
	"chrome://segmentation-internals",
	"chrome://signin-internals",
	"chrome://site-engagement",
	"chrome://suggest-internals",
	"chrome://tab-strip-internals",
	"chrome://traces",
	"chrome://traces-internals",
	"chrome://tracing",
	"chrome://translate-internals",
	"chrome://ukm",
	"chrome://user-actions",
	"chrome://user-education-internals",
	"chrome://watermark",
	"chrome://webrtc-internals",
	"chrome://webrtc-logs",
	"chrome://webui-browser",
	"chrome://webuijserror",
	"chrome://inspect",
	"chrome://serviceworker-internals",
	"chrome://web-app-internals",
	"chrome://webui-gallery",
	"chrome://webxr-internals",
	"chrome://badcastcrash",
	"chrome://crash",
	"chrome://crash/cfg",
	"chrome://crash/rust",
	"chrome://crashdump",
	"chrome://gpuclean",
	"chrome://gpucrash",
	"chrome://gpuhang",
	"chrome://hang",
	"chrome://heapcorruptioncrash",
	"chrome://inducebrowsercrashforrealz",
	"chrome://inducebrowserdcheckforrealz",
	"chrome://inducebrowserheapcorruption",
	"chrome://kill",
	"chrome://memory-exhaust",
	"chrome://memory-pressure-critical",
	"chrome://memory-pressure-moderate",
	"chrome://shorthang",
	"view-source:",
];
